import { inputFunc } from "../../lib/inputFunctions";
import "./input.css";
import { useEffect, useRef, useState } from "react";

type TextInputProps = {
  state: { [key: string]: any };
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  stateKey: string;
  list: { [key: string]: any }[];
  listKeys: string[];
  handleClick?: any;
  label?: string;
  inlineLabel?: string;
  labelWidth?: number;
  placeholder?: string;
  afterText?: string;
  errorMessage?: string;
  pattern?: { [key: string]: any };
  required?: boolean;
  readonly?: boolean;
  format?: "toNumber" | "toPhoneNumber" | "toMoney" | "toInteger";
};

export function Autocomplete({
  state,
  stateKey,
  setState,
  list,
  listKeys,
  handleClick,
  label,
  inlineLabel,
  labelWidth,
  placeholder,
  afterText,
  pattern,
  required,
  readonly,
  format,
}: TextInputProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);
  const valid = new RegExp(pattern ? pattern.pattern : "").test(state[stateKey]?.toString() ?? "");

  const onClickItem = (item: any, listKey: string) => {
    inputFunc.changeObj(item[listKey], setState, stateKey, format);
    handleClick && handleClick(item);
    setActive(false);
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="input-container autocomplete">
      {label && (
        <div className="input-label">
          <label>{label}</label>
        </div>
      )}
      <div className="input-wrapper">
        {inlineLabel && (
          <div style={{ width: labelWidth }} className="input-inline-label">
            {inlineLabel}
          </div>
        )}
        <div className="inputfield-wrapper">
          <input
            id={stateKey}
            name={stateKey}
            className={`inputfield ${inlineLabel && "inlinelabeled"} ${afterText && "aftertext"}`}
            type="text"
            value={state[stateKey] ?? ""}
            onChange={(e) => inputFunc.changeObj(e.target.value, setState, stateKey, format)}
            placeholder={placeholder}
            pattern={pattern && pattern.pattern}
            required={required}
            readOnly={readonly}
            onClick={() => setActive(active ? false : true)}
          />
        </div>
        {afterText && <div className="input-after">{afterText}</div>}
      </div>
      {pattern && state[stateKey] && !valid && <div className="input-error">{pattern.message}</div>}
      {list.length > 0 && (
        <div className={`dropdown-menu ${active ? "open" : ""}`}>
          <div
            className="dropdown-item"
            onClick={() => {
              inputFunc.changeObj("", setState, stateKey, format);
              setActive(false);
            }}>
            -- {label || inlineLabel || placeholder} --
          </div>

          {list.map((item: any, index: number) => (
            <div key={index} className="dropdown-item" onClick={() => onClickItem(item, listKeys[0])}>
              {listKeys.map((e, i) => (
                <div key={i} style={{ display: "inline-block", marginRight: 5 }}>
                  {item[e]}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
